import React from 'react';
import { Alert, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

// Ida y vuelta desde "Validar Campos" (Programas): la pantalla destino recibe
// location.state.returnToValidation = { workOrderId, orderNumber } y, al regresar, Programas
// reabre la validación de esa OT con datos nuevos (location.state.reopenValidationWorkOrderId).
export const goBackToValidation = (navigate, info) => navigate('/servicios/programas', {
  state: { reopenValidationWorkOrderId: info.workOrderId }
});

const ReturnToValidationBanner = ({ info, onReturn, autoReturn = false, sx }) => {
  if (!info) return null;
  return (
    <Alert severity="info" sx={{ mb: 2, borderRadius: 2, alignItems: 'center', ...sx }}
      action={(
        <Button color="inherit" size="small" startIcon={<ArrowBackIcon />} onClick={onReturn}
          sx={{ textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}>
          Regresar a la validación
        </Button>
      )}>
      Vienes de <strong>Validar Campos</strong>{info.orderNumber ? ` de ${info.orderNumber}` : ''}.
      {autoReturn ? ' Al guardar regresas automáticamente.' : ''}
    </Alert>
  );
};

export default ReturnToValidationBanner;
